
import { Component, Emit, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';
import store from "@shared/core/store";

@Component
export default class CircleCheck extends Vue {
    @Prop({required: true, default: false}) private selected!: boolean;

    private get isDarkMode() {
      return store.state.settings.DarkMode === true;
    }

    private get clickable(): boolean {
        return !!this.$listeners['click'];
    }

    @Emit('click')
    private onClick(event: MouseEvent) {
      return event;
    }
}
